// *******************************************************************
// DO NOT EDIT THIS FILE WITHOUT EXPLICIT SIGN OFF FROM THE MIGOS TEAM
// *******************************************************************

// The import statements below combine all of the files previously combined curalate-all.
/* eslint-disable */

// js.legacy.*
import './js/new/crl8-shared';
import './js/curalate';
import './js/curalate.query.overrides';

// js.sources.includes
import './js/jquery-mixins';
import './js/curalate.angular';
import './js/constants.angular';
import './js/countries.angular';
import './js/facebook-ad-countries.angular';
import './node_modules/pinsights-js-shared/src/main/js/directives/image-dimensions';
import './node_modules/pinsights-js-shared/src/main/js/directives/lazy-loaded-image';
import 'app/directives/twitter-typeahead';
import '@services/date-time-service';
import './node_modules/pinsights-js-shared/src/main/js/services/image-service';
import './node_modules/pinsights-js-shared/src/main/js/services/mobile-devices-service';
import './node_modules/pinsights-js-shared/src/main/js/services/processing-videos-service';
import './node_modules/pinsights-js-shared/src/main/js/services/product-tagging-service';
import './node_modules/pinsights-js-shared/src/main/js/services/promise-service';
import './node_modules/pinsights-js-shared/src/main/js/services/string-utils';
import './node_modules/pinsights-js-shared/src/main/js/services/universal-image-actions-helpers';
import './node_modules/pinsights-js-shared/src/main/js/services/universal-item-id-constants';
import './node_modules/pinsights-js-shared/src/main/js/services/url-utils';
import './node_modules/pinsights-js-shared/src/main/js/shared-constants.angular';

// js.sources.includes#app/controllers
import 'app/controllers/lift-bridge';

// js.sources.includes#app/directives
import 'app/directives/angular-contenteditable';
import 'app/directives/brand-tagger';
import 'app/directives/bv-params/pdp-url-editor.js';
import 'app/directives/charts.area';
import 'app/directives/charts.gain-loss';
import 'app/directives/check-url';
import 'app/directives/comment-suspendable';
import 'app/directives/confirmation-modal';
import 'app/directives/date-time-picker';
import 'app/directives/downloadable';
import 'app/directives/drag-sort-item';
import 'app/directives/drag-sort';
import 'app/directives/fancy-checkbox';
import 'app/directives/fancy-radio-button';
import 'app/directives/fanreel-product-name/fanreel-product-name';
import 'app/directives/inline-warning';
import 'app/directives/loadable';
import 'app/directives/media-error';
import 'app/directives/multi-column';
import 'app/directives/ng-table-ex';
import 'app/directives/pagination-controls';
import 'app/directives/placeholder-block';
import 'app/directives/product-tag';
import 'app/directives/relative-time';
import 'app/directives/required-permissions';
import 'app/directives/scroll-to-listener';
import 'app/directives/search-bar';
import 'app/directives/simple';
import 'app/directives/social-icon';
import 'app/directives/social-image';
import 'app/directives/social-item';
import 'app/directives/social-user-link';
import 'app/directives/stat-bubble';
import 'app/directives/sticky';
import 'app/directives/suspendable';
import 'app/directives/table-pagination';
import 'app/directives/tagger-tag';
import 'app/directives/tagger';
import 'app/directives/thumbnail-popover';
import 'app/directives/toggle-option';
import 'app/directives/toggle';
import 'app/directives/tracking-params/tracking-params-inline-editor.js';
import 'app/directives/tracking-params/tracking-params-switch-autofill.js';
import 'app/directives/tracking-params/tracking-params-switch-input.js';
import 'app/directives/tracking-params/tracking-params-switch-reserved.js';
import 'app/directives/tracking-params/tracking-params.js';
import 'app/directives/truncated-text';
import 'app/directives/twitter-multi-typeahead';

// js.sources.includes#app/filters
import 'app/filters/address-formatter';
import 'app/filters/capitalize';
import 'app/filters/emoji';
import 'app/filters/grammatically-correct-list';
import 'app/filters/hashtag';
import 'app/filters/html-encode';
import 'app/filters/order-object-by';
import 'app/filters/product-feed-health-status-filter';
import 'app/filters/product-feed-protocols';
import 'app/filters/readable-number';
import 'app/filters/stat-bubble-formatter';
import 'app/filters/static-relative-time';

// js.sources.includes#app/services
import 'app/services/account-settings-service';
import 'app/services/analytics-settings-service';
import 'app/services/assisted-product-tagging-service';

import 'app/services/collections-api-service';
import 'app/services/collections-settings-service';
import 'app/services/content-library-api-service';
import 'app/services/content-library-helper';
import 'app/services/content-library-item-details-service';
import 'app/services/content-library-items-service';
import 'app/services/content-library-service';
import 'app/services/dynamic-anchor-scroll';
import 'app/services/ecommerce-integrations-api-service';
import 'app/services/ecommerce-integrations-service';
import 'app/services/environment-service';
import 'app/services/error-notification-service';
import 'app/services/es6-shim-service';
import 'app/services/fanreel-analytics-service';
import 'app/services/fanreel-service';
import 'app/services/hashtags-service';
import 'app/services/instagram-accounts-service';
import 'app/services/instagram-settings-service';
import 'app/services/labels-service';
import 'app/services/like2buy-analytics-service';
import 'app/services/listening-inbox-brand-service';
import 'app/services/logging-service';
import 'app/services/metrics-helper';
import 'app/services/minimal-toast-notification-service';
import 'app/services/ng-table-params-ex';
import 'app/services/notes-api-service';
import 'app/services/notes-service';
import 'app/angular-apis/productFeedHealthApi.service';
import 'app/services/product-feed-health-service';
import 'app/services/product-search-service';
import 'app/services/queued-uploader-service';
import 'app/services/scheduler-service';
import 'app/services/scroll-animation-service';
import 'app/services/search-filter-service-helper';
import 'app/services/session-date-service';
import 'app/services/syndication-service';
import 'app/services/tagger-sanitization';
import 'app/angular-apis/teamManagementApi.service';
import 'app/services/toast-notification-service';
import 'app/services/tracked-sources-service';
import 'app/services/tracking-params-service';
import 'app/services/twitter-settings-service';
import 'app/services/universal-image-actions-tracking-service';
import 'app/services/unsaved-changes-service';
import 'app/services/users-service';
import 'app/angular-apis/videoProcessingApi.service';
import 'app/angular-apis/trackedSourcesApi.service';
import 'app/services/window-title-service';

// js.sources.includes#@legacy-components + main.ts
import '@legacy-components/common/click-outside';
import '@legacy-components/common/content-card/content-card-helper';
import '@legacy-components/common/content-card/content-card-toggle';
import '@legacy-components/common/content-source-badge/content-source-badge-avatar';
import '@legacy-components/common/content-source-badge/content-source-badge';
import '@legacy-components/common/copy-button/copy-button';
import '@legacy-components/common/datatable/datatable';
import '@legacy-components/common/datatable/datatable-empty';
import '@legacy-components/common/datatable/datatable-grid';
import '@legacy-components/common/datatable/datatable-header';
import '@legacy-components/common/datatable/datatable-list';
import '@legacy-components/common/datatable/datatable-loading-overlay';
import '@legacy-components/common/datatable/datatable-multi-column';
import '@legacy-components/common/datatable/datatable-pagination';
import '@legacy-components/common/datatable/datatable-service';
import '@legacy-components/common/datatable/datatable-table';
import '@legacy-components/common/donut-chart/donut-chart';
import '@legacy-components/common/dropdown/dropdown-option';
import '@legacy-components/common/dropdown/dropdown';
import '@legacy-components/common/emoji-typeahead/emoji-typeahead-strategy';
import '@legacy-components/common/emoji-typeahead/emoji-typeahead';
import '@legacy-components/common/flash-utils';
import '@legacy-components/common/form-utils';
import '@legacy-components/common/hotkeys';
import '@legacy-components/common/image-uploader/dropdown-mouseout-hide';
import '@legacy-components/common/image-uploader/image-uploader';
// Added after first rebase
import '@legacy-components/common/indeterminate-checkbox/indeterminate-checkbox';
import '@legacy-components/common/isotope';
import '@legacy-components/common/lacking-permissions-label';
import '@legacy-components/common/linked-text';
import '@legacy-components/common/loading-element/loading-element';
import '@legacy-components/common/processing-video/processing-video';
import '@legacy-components/common/product-list/product-list';
import '@legacy-components/common/progress-bar';
import '@legacy-components/common/queued-upload/queued-upload';
import '@legacy-components/common/scroll-emulator-service';
import '@legacy-components/common/scroll-lock';
import '@legacy-components/common/scroll-mask/scroll-mask';
import '@legacy-components/common/session-date-range-picker';
import '@legacy-components/common/stat-bubble-v2/stat-bubble-v2';
import '@legacy-components/common/svg-icon';
import '@legacy-components/common/switch';
import '@legacy-components/common/system-alerts/error-alerts';
import '@legacy-components/common/system-alerts/info-alerts';
import '@legacy-components/common/system-alerts/system-alerts-service';
import '@legacy-components/common/toggle-switch';
import '@legacy-components/common/universal-image-actions/custom-action';
import '@legacy-components/common/universal-image-actions/global-uia-launcher';
import '@legacy-components/common/universal-image-actions/item-history-service';
import '@legacy-components/common/universal-image-actions/item-launch-options';
import '@legacy-components/common/universal-image-actions/showroom-api-service';
import '@legacy-components/common/universal-image-actions/showroom-product-filter-typeahead';
import '@legacy-components/common/universal-image-actions/showroom-service';
import '@legacy-components/common/universal-image-actions/showroom-settings-filters';
import '@legacy-components/common/universal-image-actions/showroom-settings-passthrough';
import '@legacy-components/common/universal-image-actions/showroom-settings-tracking-params';
import '@legacy-components/common/universal-image-actions/tracking-params-typeahead';
import '@legacy-components/common/universal-image-actions/tributary-link';
import '@legacy-components/common/universal-image-actions/tributary-url-tags-warning';
import '@legacy-components/common/universal-image-actions/universal-image-actions-config';
import '@legacy-components/common/universal-image-actions/universal-image-actions-constants';
import '@legacy-components/common/universal-image-actions/universal-image-actions-fanreel-buttons';
import '@legacy-components/common/universal-image-actions/universal-image-actions-fanreel';
import '@legacy-components/common/universal-image-actions/universal-image-actions-modal';
import '@legacy-components/common/universal-image-actions/universal-image-actions-note-subscribers-typeahead';
import '@legacy-components/common/universal-image-actions/universal-image-actions-notes-note';
import '@legacy-components/common/universal-image-actions/universal-image-actions-notes';
import '@legacy-components/common/universal-image-actions/universal-image-actions-productize-catalog-selector';
import '@legacy-components/common/universal-image-actions/universal-image-actions-productize-editor';
import '@legacy-components/common/universal-image-actions/universal-image-actions-productize-empty-state';
import '@legacy-components/common/universal-image-actions/universal-image-actions-productize-grid-item';
import '@legacy-components/common/universal-image-actions/universal-image-actions-productize-grid';
import '@legacy-components/common/universal-image-actions/universal-image-actions-productize-list';
import '@legacy-components/common/universal-image-actions/universal-image-actions-productize-overlay';
import '@legacy-components/common/universal-image-actions/universal-image-actions-productize-search-bar';
import '@legacy-components/common/universal-image-actions/universal-image-actions-productize';
import '@legacy-components/common/universal-image-actions/universal-image-actions-reveal-buttons';
import '@legacy-components/common/universal-image-actions/universal-image-actions-reveal-v2';
import '@legacy-components/common/universal-image-actions/universal-image-actions-reveal';
import '@legacy-components/common/universal-image-actions/universal-image-actions-rights-options-service';
import '@legacy-components/common/universal-image-actions/universal-image-actions-rights-request';
import '@legacy-components/common/universal-image-actions/universal-image-actions-schedule-now';
import '@legacy-components/common/universal-image-actions/universal-image-actions-service';
import '@legacy-components/common/universal-image-actions/universal-image-actions-tributary-buttons';
import '@legacy-components/common/universal-image-actions/universal-image-actions-tributary-typeahead';
import '@legacy-components/common/universal-image-actions/universal-image-actions-tributary';
import '@legacy-components/common/universal-image-actions/universal-image-actions-workflow';
import '@legacy-components/common/universal-source-actions/track-source-button';
import '@legacy-components/common/universal-source-actions/universal-source-actions-menu';
import '@legacy-components/common/universal-uploader/universal-upload-overlay-host';
import '@legacy-components/common/widgets/widget-embed-code-modal';
import '@legacy-components/content/collections-closable-sidebar-filters/collections-closable-sidebar-filters';
import '@legacy-components/content/collections-sidebar-filters.js';
import '@legacy-components/content/collection-filters-converter';
import '@legacy-components/content/collections-service';
import '@legacy-components/content/content-collections-sidebar';
import '@legacy-components/content/content-library-labels-filter-section';
import '@legacy-components/content/content-library-quick-search-filter/content-library-quick-search-filter';
import '@legacy-components/content/content-library-sidebar-filters';
import '@legacy-components/content/content-library-users-filter-section';
import '@legacy-components/content/content-responsive-filters-sidebar';
import '@legacy-components/discover/detail-v2/content-constants';
import '@legacy-components/discover/detail-v2/source-tracking-status';
import '@legacy-components/discover/influencers/influencers-service';
import '@legacy-components/ecommerce-integrations/ecommerce-integrations-configure';
import '@legacy-components/ecommerce-integrations/ecommerce-integrations-connected';
import '@legacy-components/ecommerce-integrations/ecommerce-integrations-connecting-async';
import '@legacy-components/ecommerce-integrations/ecommerce-integrations-constants';
import '@legacy-components/ecommerce-integrations/ecommerce-integrations-faq-footer';
import '@legacy-components/ecommerce-integrations/ecommerce-integrations-start';
import '@legacy-components/ecommerce-integrations/ecommerce-integrations';
import '@legacy-components/ecommerce-integrations/integrations/magento-integration';
import '@legacy-components/ecommerce-integrations/integrations/shopify-integration';
import '@legacy-components/filters/collapsable-section';
import '@legacy-components/filters/distribution-search-filter';
import '@legacy-components/filters/pretty-print-search-filter';
import '@legacy-components/filters/search-filter-caching-service-helper';
import '@legacy-components/filters/search-filter-caching-service';
import '@legacy-components/filters/search-filter-checkbox-group';
import '@legacy-components/filters/search-filter-checkbox';
import '@legacy-components/filters/search-filter-constants';
import '@legacy-components/filters/search-filter-cu-dropdown';
import '@legacy-components/filters/search-filter-date-picker';
import '@legacy-components/filters/search-filter-dropdown';
import '@legacy-components/filters/search-filter-gallery';
import '@legacy-components/filters/search-filter-loadable';
import '@legacy-components/filters/search-filter-nested-checkbox-service';
import '@legacy-components/filters/search-filter-nested-checkbox/search-filter-nested-checkbox';
import '@legacy-components/filters/search-filter-radio-buttons';
import '@legacy-components/filters/search-filter-save-button';
import '@legacy-components/filters/search-filter-service';
import '@legacy-components/filters/search-filter-set-summary';
import '@legacy-components/filters/search-filter-set';
import '@legacy-components/filters/search-filter-single-selector';
import '@legacy-components/filters/search-filter-semantic-tags-search-bar';
import '@legacy-components/filters/search-filter-social-search-bar';
import '@legacy-components/filters/search-filter-social-search-state';
import '@legacy-components/filters/search-filter';
import '@legacy-components/filters/search-fiter-social-search-bar-service';
import '@legacy-components/filters/users-filter-dropdown';
import '@legacy-components/intelligent-product-tagging/product-suggestion-bounding-box';
import '@legacy-components/intelligent-product-tagging/product-suggestion-overlay';
import '@legacy-components/intelligent-product-tagging/product-suggestions-feedback-form';
import '@legacy-components/internal-employee-banner/internal-employee-banner';
import '@legacy-components/settings-menu/brand-picker-menu-item/brand-picker-menu-item';
import '@legacy-components/settings-menu/client-group-display';
import '@legacy-components/common/post-count-trend-graph/post-count-trend-graph';
import '@legacy-components/common/social-deprecation-notice';
import '@legacy-components/common/tracking/record-click-event';
import '@legacy-components/fanreel-self-serve-customization/fanreel-customization-service';
import '@legacy-components/common/photo-editor-beautify/photo-editor-beautify-button';
import '@legacy-components/common/no-instagram-business-connected-tooltip/no-instagram-business-connected-tooltip';
import '@legacy-components/common/required-permissions-tooltip';
import '@legacy-components/common/copy-button/clipboard-service';
import '@legacy-components/common/universal-image-actions/showroom-mobile-preview';
import '@legacy-components/common/universal-image-actions/showroom-mobile-preview-buttons';
import '@legacy-components/common/universal-image-actions/showroom-settings-custom-strings';
import '@legacy-components/common/universal-image-actions/showroom-settings-customize-media';
import '@legacy-components/common/universal-image-actions/showroom-settings-customize-products';
import '@legacy-components/common/universal-image-actions/showroom-settings-email-capture';
import '@legacy-components/common/universal-image-actions/showroom-settings-empty-content-warning';
import '@legacy-components/common/universal-image-actions/showroom-settings-filters-labels';
import '@legacy-components/common/universal-image-actions/showroom-settings-filters-products';
import '@legacy-components/common/universal-image-actions/universal-image-actions-api-service';
import '@legacy-components/common/universal-image-actions/universal-image-actions-productize-sku-limits';
import '@legacy-components/common/universal-image-actions/universal-image-actions-rights-request-oauth-service';
import '@legacy-components/common/universal-image-actions/universal-image-actions-tributary-add-ons';
import '@legacy-components/common/universal-image-actions/universal-image-actions-tributary-customize-links';
import '@legacy-components/common/universal-image-actions/universal-image-actions-tributary-customize-media';
import '@legacy-components/common/universal-image-actions/universal-image-actions-tributary-customize-products';
import '@legacy-components/required-features/required-features';
import '@legacy-components/page-layout-simple/page-layout-simple';
import '@legacy-components/pinterest-bookmarklet/pinterest-bookmarklet';
import '@legacy-components/rights-management/rights-configuration-modal.ts';
import '@legacy-components/rights-management/rights-management-page.js';
import '@legacy-components/rights-management/rights-management-service.js';

// js.sources.includes#app/initialization
import 'app/initialization/ga/ga';

// main.ts
import '@legacy-components/nav3/top-navigation-refreshed';
import '@legacy-components/welcome-screen/welcome-screen';
import 'app/filters/arrays';
import 'app/filters/country';
import 'app/filters/meds';
import 'app/filters/moment-format';
import 'app/filters/really-readable-number';
import 'app/services/api-gateway-interceptor';
import 'app/services/amplify-service';
import 'app/services/check-url-service';
import 'app/services/cognito-token-interceptor';
import 'app/services/core-api-service';
import 'app/services/customize-like2buy-service';
import 'app/services/experiences-api-service';
import 'app/services/experiences-integrations-service';
import 'app/services/experiences-service';
import 'app/services/experiments-service';
import 'app/services/google-analytics-connection-service';
import 'app/services/guid-service';
import 'app/services/image-metadata-service';
import 'app/services/permissions';
import 'app/services/permissions-service';
import 'app/services/session-vars-service';
import 'app/services/showroom-metrics-api-service';
import 'app/angular-apis/dataSourceApi.service';
import 'app/angular-apis/gatewayAuthenticationApi.service';
import 'app/universal-image-actions-modal/approve-for-galleries/ApproveForGalleriesPanel';
import 'app/universal-image-actions-modal/approve-for-galleries/ApproveForGalleriesButtons';
import 'app/universal-image-actions-modal/uia-workflow/uia-workflow-actions';
// Added after first rebase
import 'app/apis/instagram-hashtags-usage/instagramHashtagsUsageApi';
import 'app/link-icon/link-icon';
import 'app/non-business-tooltip/non-business-tooltip';
import 'app/product-link-icon/product-link-icon';
import 'app/streams-drawer/streams-drawer-container/streams-drawer-container';
import 'app/styled-link-icon/styled-link-icon';
import 'app/bulk-actions/bulk-actions-container/bulk-actions-container';
import 'app/bulk-actions/bulk-actions-overlay/bulk-actions-overlay';
import 'app/content-drawer/header-content-drawer-trigger';
import '@uia/details/UniversalImageActionsDetails';
import '@uia/rights/UIARightsFlow';
import '@uia/labels/UniversalImageActionsLabels';
import '@uia/products/UniversalImageActionsProducts';
// Added after first rebase
import 'app/constants/graph-api-hashtag-limit.ts';
// Additional imports originally in the library app
import '@legacy-components/content/collection-metrics.js';
import '@legacy-components/content/collection-naming-modal.js';
import '@legacy-components/content/collection-source-add-menu.js';
import '@legacy-components/content/content-empty-state.js';
import '@legacy-components/content/content-library-content-grid-with-filters/content-library-content-grid-with-filters.js';
import '@legacy-components/content/content-library-content-grid/content-library-content-grid.js';
import '@legacy-components/content/content-library-semantic-tags-filter-section.js';
import '@legacy-components/content/content-library-social-search-filter-section.js';
import '@legacy-components/content/content-remove-filters-empty-state.js';
import '@legacy-components/content/create-new-collection-button.js';
import '@legacy-components/content/library-empty-state.js';
import '@legacy-components/content/search-and-add-menu.js';
import '@legacy-components/content/semantic-tags-filter-alias-helper.js';
import '@legacy-components/content/social-filter-alias-helper.js';
import '@legacy-components/content/sources-dropdown/sources-dropdown.js';
import '@legacy-components/content/sources-modal/sources-modal.js';
import '@legacy-components/content/sources-tree/sources-tree.js';

import '@redux/content-drawer/ContentDrawerSettingsService';
import '@services/labels-api-service';
